import { AppStore } from '../store';
import { type IkeClientService, Services } from './index';

export interface RenameTagParams {
	tagName: string;
	revisions: string[];
}

export class TagService implements IkeClientService {
	__priority = 100;

	async refresh(tagIds: string[]): Promise<any> {
		await AppStore.Tag.refresh();

		const promises: Promise<any>[] = [];
		for (const tagId of tagIds) {
			promises.push(AppStore.TagSummary.getFetchable(tagId).refetch());
		}

		await Promise.all(promises);

		return Services.Search.search();
	}

	async rename(tagId: string, newName: string) {
		const rest = Services.Department.rest;

		let tag = AppStore.Tag.get(tagId);
		tag.name = newName;

		const newTagJson = await rest.save(rest.Objects.Tag, tag);
		await this.refresh([newTagJson.objectId]);

		return newTagJson;
	}
}
